/*
 * @Author: yangxu
 * @Description:
 * @Date: 2023-08-30 17:15:12
 * @LastEditTime: 2025-03-13 09:43:36
 * @FilePath: /js_zuhe-2023_src/src/main.ts
 */
import { createApp } from 'vue';
import App from './App.vue';
// import 'amfe-flexible/index.js';
import store from './store/index';
import '@/assets/css/indexh5.css';
import 'vant/lib/index.css';
import {
	Checkbox,
	CheckboxGroup,
	Icon,
	Swipe,
	Form,
	SwipeItem,
	Field,
	Button,
	Tab,
	Tabs,
	Popup,
	Toast,
	Dialog,
	NoticeBar,
	Popover,
	Switch,
	Divider,
	TextEllipsis,
} from 'vant';
createApp(App)
	.use(Checkbox)
	.use(CheckboxGroup)
	.use(Icon)
	.use(Field)
	.use(Form)
	.use(Button)
	.use(Tab)
	.use(Tabs)
	.use(Popup)
	.use(Swipe)
	.use(SwipeItem)
	.use(Dialog)
	.use(Toast)
	.use(NoticeBar)
	.use(Popover)
	.use(Switch)
	.use(Divider)
	.use(TextEllipsis)
	.use(store)
	.mount('#app');
	
